export const DEV_ENVIRONMENT = "dev";
export const TEST_ENVIRONMENT = "test";
export const STAGE_ENVIRONMENT = "stage";
export const PRODUCTION_ENVIRONMENT = "production";
